/**
 * AURUM Finance — Weight Converter
 * Convert between troy ounces, grams, kg, grain, pennyweight, tola, tael, baht
 */
(function () {
  var rates = {
    ozt: 31.1034768,
    g: 1,
    kg: 1000,
    gr: 0.06479891,
    dwt: 1.55517384,
    tola: 11.6638038,
    tael: 37.429,
    baht: 15.244
  };

  var valEl = document.getElementById('convVal');
  var fromEl = document.getElementById('convFrom');
  var toEl = document.getElementById('convTo');
  var outEl = document.getElementById('convOut');
  var unitEl = document.getElementById('convOutUnit');
  var swapBtn = document.getElementById('convSwap');

  function convert() {
    if (!valEl || !fromEl || !toEl || !outEl) return;
    var val = parseFloat(valEl.value) || 0;
    var grams = val * rates[fromEl.value];
    var result = grams / rates[toEl.value];
    outEl.textContent = result < 0.01 ? result.toFixed(5) : result.toFixed(4);
    if (unitEl) {
      var opt = toEl.options[toEl.selectedIndex];
      unitEl.textContent = opt ? opt.text : '';
    }
  }

  if (valEl) valEl.addEventListener('input', convert);
  if (fromEl) fromEl.addEventListener('change', convert);
  if (toEl) toEl.addEventListener('change', convert);

  if (swapBtn) {
    swapBtn.addEventListener('click', function () {
      var tmp = fromEl.value;
      fromEl.value = toEl.value;
      toEl.value = tmp;
      convert();
    });
  }

  convert();
})();
